<div fxLayout="row" fxLayoutAlign="center">
  <div fxFlex="0 1 auto">
    <p-panel>
      <p-header>
        <h2>Login</h2>
      </p-header>
      @if (false) {
        <form name="form" (ngSubmit)="f.form.valid && login()" #f="ngForm" novalidate >
          @if (false) {
            <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
              <label for="username">Username</label>
              <input type="text" class="form-control" name="username" [(ngModel)]="model.username" #username="ngModel" required />
              @if (f.submitted && !username.valid) {
                <div class="help-block">Username is required</div>
              }
            </div>
          }
          @if (false) {
            <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !password.valid }">
              <label for="password">Password</label>
              <input type="password" class="form-control" name="password" [(ngModel)]="model.password" #password="ngModel" required />
              @if (f.submitted && !password.valid) {
                <div class="help-block">Password is required</div>
              }
            </div>
          }
          <div class="form-group">
            <button [disabled]="loading" class="btn btn-primary">Login</button>
            @if (false) {
              <div class="forgotten-password"><a [routerLink]="['/login/forgotten']">Forgot your password</a></div>
            }
            @if (loading) {
<img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
}
		        </div>
		        @if (error) {
<div class="alert alert-danger">{{error}}</div>
}
		    </form>
}
		</p-panel>
    </div>
</div>
